import React, { Component } from "react";
import { Container, Row } from "reactstrap";

//Import Section Title
import SectionTitle from "../common/section-title";

//Import Service Box
import ServiceBox from "./service-box";

class Services extends Component {
  state = {
    services: [
      {
        title: "Mantenimientos",
        icon: "pe-7s-tools", // icono de usuario para enfoque en el estudiante
        description:
          "Mantenimiento a Cuartos Eléctrico, Mantenimientos especializados y de diagnostico a estaciones de servicio.",
      },
      {
        title: "Instalaciones",
        icon: "pe-7s-hammer", // icono de globo para diversidad e inclusión
        description:
          "Instalación, calibración de sonda de medición, Accesorios de Tanques de Almacenamiento, Puesta En Marcha De Dispensarios (Bennett Y Gilbarco), Equipos De Monitoreo Veeder Root.",
      },
      {
        title: "Ventas",
        icon: "pe-7s-cash", // icono de libro para aprendizaje continuo
        description:
          "Venta De Refacciones Para Estaciones De Servicio, Dispensarios, Tanques de Almacenamiento, Auto abastos, Unidades de Reparto.",
      },
      {
        title: "Evaluaciones",
        icon: "pe-7s-news-paper", // icono de portafolio para facultad experimentada
        description:
          "Evaluación Bajo Norma NOM-005-ASEA-2016 a Estación de Servicio.",
      },
      {
        title: "Dispensarios",
        icon: "pe-7s-paint-bucket", // icono de maletín para prácticas y pasantías
        description:
          "Inspección, Calibración, Dictaminación De Dispensarios.",
      },
      {
        title: "Unidades de Reparto",
        icon: "pe-7s-car", // icono de pantalla para cursos en línea
        description:
          "Servicio, Calibración y Mantenimiento a Unidades de Reparto de Flujo Bajo Instrumentación y Medición de Normas Internacionales.",
      },
      
    ]

  };
  render() {
    return (
      <React.Fragment>
        <section className="section bg-light bg-home-serv" style={{ boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)', position: 'relative', overflow: 'hidden' }} id="services">
          <div className="bg-image">
            <div className="bg-overlay-serv"></div>
          </div>
          <Container style={{ position: 'relative', zIndex: 2 }}>
            {/* Render section title */}
            <SectionTitle
              title="Nuestros Servicios"
              description="Contamos con múltiples servicios"
            />

            <Row className="mt-5">
              {/* Render service box */}
              {this.state.services.map((service, key) => (
                <ServiceBox
                  key={key}
                  title={service.title}
                  icon={service.icon}
                  description={service.description}
                />
              ))}
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Services;
